import { Metrics } from './Metrics';
export const getRequestErrorClass = error => {
  if (!error || typeof error !== 'object') {
    return 'unknown';
  }
  const {
    errorCode,
    status
  } = error;
  if (errorCode === 'ABORT') {
    return 'aborted';
  }
  if (errorCode === 'TIMEOUT') {
    return 'timeout';
  }
  if (typeof status !== 'number') {
    return 'unknown';
  }
  if (status === 0) {
    return 'network';
  }
  if (status >= 400 && status < 500) {
    return '4xx';
  }
  if (status >= 500) {
    return '5xx';
  }
  return 'unknown';
};
export const trackRequest = name => {
  const startTime = performance.now();
  const updateLatency = status => {
    Metrics.timer(`${name}-latency`, {
      status
    }).update(performance.now() - startTime);
  };
  return {
    success: () => {
      updateLatency('success');
      Metrics.counter(`${name}-success`).increment();
      Metrics.counter(name, {
        status: 'success'
      }).increment();
    },
    failure: error => {
      updateLatency('failure');
      Metrics.counter(`${name}-failure`).increment();
      Metrics.counter(name, {
        status: 'failure',
        errorClass: getRequestErrorClass(error)
      }).increment();
    }
  };
};